import { Controller } from "stimulus";

export default class extends Controller {
  static get targets() {
    return ["ip", "quick_connect", "trigger", "password_text", "donation_link"];
  }
  initialize() {
    // console.log("Miniutils controller is working!");
  }
  connect() {
    const password = this.password_textTarget;
    const trigger = this.triggerTarget;
    const origValue = password.getAttribute("data-pass");  //data_pass attribute on html
    const hiddenValue = password.innerText; // asterisks
    trigger.addEventListener("click", () => {
      password.innerText === hiddenValue ? password.innerText = origValue : password.innerText = hiddenValue;
    });
  }
  copyIpAddress() {
    const ipAddress = this.ipTarget;  
    ipAddress.select();
    ipAddress.setSelectionRange(0, 99999)
    document.execCommand("copy");
  }
  copyQuickConnect() {
    const quickConnectAddress = this.quick_connectTarget;
    quickConnectAddress.select();
    quickConnectAddress.setSelectionRange(0, 99999)
    document.execCommand("copy");
  }
  copyDonationLink() {
    const donationLink = this.donation_linkTarget;
    donationLink.select();
    donationLink.setSelectionRange(0, 99999)
    document.execCommand("copy");
  }
}